import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core';
import { useTheme } from '@mui/material';
import axios from 'axios'
import { useNavigate } from 'react-router-dom';
import { Button, Dialog, DialogActions, DialogTitle, FormControl, Select, MenuItem } from '@mui/material'
import { setPageAll } from '../../../redux/pageSlice';
import { useDispatch } from 'react-redux';

const ShopMenuListStyles = makeStyles((theme) => ({
    ShopMenuListBlock:{
        padding:'235px 0 0 0',

        fontFamily:[
            'Noto Sans KR'
        ],

        [theme.breakpoints.down(1025)]: {
            padding:'132px 0 0 0',
        },
    },
    ShopMenuListTitleBlock:{
        height:'200px',
        maxWidth: 1902,
        margin: '0px auto',
        position:'relative',
        backgroundSize: '100% 200px',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        [theme.breakpoints.down(1025)]: {
            display:'none',
        },
    },
    ShopMenuListTitleBlockmobile:{
        display:'none',
        [theme.breakpoints.down(1025)]: {
            display:'block',
            height:'200px',
            width: '100%',
            position:'relative',
            backgroundSize: '100% 200px',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
        },
    },
    ShopMenuListH1:{
        fontSize:'38px',
        fontWeight:'500',
        letterSpacing: '-1.9px',
        paddingBottom:'10px',
        position:'absolute',
        top:'40%',
        left:'50%',
        transform:'translate( -50%, -50%)',
        fontFamily:[
            'Noto Sans KR'
        ],
        [theme.breakpoints.down(1025)]: {
            fontSize:'2.5rem',
        },
    },
    ShopMenuListSpan:{
        textAlign:'center',
        position:'absolute',
        top:'60%',
        left:'50%',
        transform:'translate( -50%, -50%)',
        fontFamily:[
            'Noto Sans KR'
        ],
        [theme.breakpoints.down(1025)]: {
            paddingTop: 10,
        },
    },
    row:{
        width:'1100px', 
        margin:'0 auto', 
        position:'relative',
        position:'absolute',
        top:'480px',
        left:'50%',
        transform:'translate(-50%, -50%)',
    },
    menuListDiv:{
        border:'1px solid #E2E2E2',
        width:'100%', 
        background:'#fff',
        display:'flex',
        flexWrap:'wrap',
        justifyContent:'space-evenly',
        padding:'15px',
        display: 'grid',
        gridTemplateColumns: 'repeat(6, 1fr)',

        [theme.breakpoints.down(1025)]: {
            display:'none',
        },
    },
    menuDiv:{
        color:'#555555',
        paddingLeft:'19px',
        letterSpacing: '-0.8px',
        cursor: 'pointer',   
        borderLeft: '1px solid #DCDCDC',
        "&:hover": {
            color: '#007235',
        },   
        
        [theme.breakpoints.down(1025)]: {
            display:'flex',    
            padding:'0 0 8px 0',
            width:'270px',
        },
    },
    row2:{
        maxWidth:'300px', 
        margin:'0 auto', 
        position:'relative',

    },
    mobileAccordion:{
        display:'none',
        position:'absolute',
        top:'-25px',
        left:'0%',
        boxShadow: '0 2px 10px rgba(0,0,0,0.30)',

        [theme.breakpoints.down(1025)]: {
            display:'block',
            
        },
    },
    arrowIcon:{
        fontSize:'25px',
        color:'#007235'
    },
}));

const ShopMenuList = ({caId}) => {
    const dispatch = useDispatch()
    let navigate = useNavigate();
    const theme = useTheme(); 
    const classes = ShopMenuListStyles(theme);
    const [cate1, setCate1] = useState([])
    const [menuList, setMenuList] = useState([])
    const [dialog, setDialog] = useState('');
    const [menuVal, setMenuVal] = useState('0');
    const bannImg = {
        12: 'url(/images/rose_banner.png)',
        13: 'url(/images/ko_banner.png)',
        14: 'url(/images/fo_banner-2.png)',
        15: 'url(/images/carnation_banner.png)',
        16: 'url(/images/material_banner-1.png)',
    }
    const mobilebannImg = {
        12: 'url(/images/mobile_rose_banner.png)',
        13: 'url(/images/mobile_ko_banner.png)',
        14: 'url(/images/mobile_fo_banner-2.png)',
        15: 'url(/images/mobile_carnation_banner.png)',
        16: 'url(/images/mobile_material_banner-1.png)',
    }
    

    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: 48 * 4.5 + 8,
                width: 250,
            },
        },
    };

    const getItem = async() => {
        if (!caId) return 
        if(caId.length === 2) {
            setMenuVal('0')
        }

        try {
            const res = await axios.post('/api/shop/getCates/', {ca_id: caId.substr(0, 2)})

            if(res.data.success === false) {
                setDialog('불러오기 실패')
                return
            }
            const result = res.data.result

            const type1 = result.filter((itm) => itm.ca_id.length === 2)
            const type2 = result.filter((itm) => itm.ca_id.length === 4)

            const menuRedu = type2.reduce((result, item) => ([...result, item.ca_name]), []).sort()

            const menuRedu2 = menuRedu.reduce((result, item) => {
                let fideId = type2.find((itm) => {
                    return itm.ca_name === item
                }).ca_id
                return [...result, {ca_id: fideId, ca_name: item}]
            }, [])

            setCate1(type1)
            setMenuList([{ca_id: '0', ca_name: '전체보기'}, ...menuRedu2])
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        return () => {
            setMenuList([])
        }
    }, [])

    useEffect(() => {
        getItem()
        
    }, [caId])

    const onCate2 = (id) => {
        if (id === '0') {
            navigate("/ShopMain/ShopList", {
                state: { caId: caId.substr(0, 2) }
            });
            return;
        }

        navigate("/ShopMain/ShopList", {
            state: { caId: id }
        });
    }


    return(
        <div className={classes.ShopMenuListBlock}>           
            <div 
                className={classes.ShopMenuListTitleBlock} 
                style={{ backgroundImage: bannImg[caId.substr(0, 2)]}}
            >
                <h1 className={classes.ShopMenuListH1}>{cate1.length > 0 && cate1[0].ca_name}</h1>
                <span className={classes.ShopMenuListSpan}>
                    생초플라워의 꽃 전문가들이 선택한 가장 신선한 꽃
                </span>
            </div>
            <div 
                className={classes.ShopMenuListTitleBlockmobile} 
                style={{ backgroundImage: mobilebannImg[caId.substr(0, 2)]}}
            >
                <h1 className={classes.ShopMenuListH1}>{cate1.length > 0 && cate1[0].ca_name}</h1>
                <span className={classes.ShopMenuListSpan}>
                    생초플라워의 꽃 전문가들이 선택한 가장 신선한 꽃
                </span>
            </div>

                <div className={classes.row}>
                    <div className={classes.menuListDiv}>
                        {menuList.length > 0 && menuList.map( (menu, index) => {
                            if (menu.ca_id === '0') return
                            return( 
                                <div 
                                    key={index} 
                                    className={classes.menuDiv}
                                    onClick={() => {
                                        dispatch(setPageAll(1))
                                        onCate2(menu.ca_id)
                                    }}
                                >
                                    {menu.ca_name}
                                </div>)
                        })}
                    </div>
                </div>            
            
            
            <div className={classes.row2}>
                <div className={classes.mobileAccordion}>
                    <FormControl 
                        sx={{ m: 1, width: 280, backgroundColor: '#fff', margin:'0',}}>
                        <Select
                            value={menuVal}
                            onChange={(e) => setMenuVal(e.target.value)}
                            inputProps={{ 
                                'aria-label': 'Without label' ,
                            }}
                            MenuProps={MenuProps}
                            sx={{
                                backgroundColor: '#fff',
                                '.MuiOutlinedInput-notchedOutline': {
                                    border: 'none',
                                },
                            }}
                        >      
                            {menuList.length > 0 && menuList.map( (menu, index) => ( 
                                <MenuItem
                                    key={index} 
                                    onClick={() => {
                                        dispatch(setPageAll(1))
                                        onCate2(menu.ca_id)
                                    }}
                                    value={menu.ca_id}
                                >
                                    {menu.ca_name}
                                </MenuItem>
                            ))}
                            
                        </Select>
                    </FormControl>
                
                </div>
            </div>
            <Dialog
                open={dialog === '' ? false : true}
                onClose={() => setDialog('')}
            >
            <DialogTitle id="alert-dialog-title">
                {dialog}
            </DialogTitle>
            <DialogActions>
                <Button onClick={() => setDialog('')} autoFocus>
                확인
                </Button>
            </DialogActions>
            </Dialog>
        </div>
    )
};

export default ShopMenuList;